import { useCallback, useState } from 'react';

export function usePluginHostState(): {
  pluginHostStateById: Record<string, unknown>;
  setPluginHostState: (pluginId: string, next: unknown) => void;
} {
  const [pluginHostStateById, setPluginHostStateById] = useState<Record<string, unknown>>({});

  const setPluginHostState = useCallback((pluginId: string, next: unknown) => {
    setPluginHostStateById((prev) => {
      if (prev[pluginId] === next) return prev;
      return { ...prev, [pluginId]: next };
    });
  }, []);

  return { pluginHostStateById, setPluginHostState };
}
